import { Component, OnInit, ViewChild } from '@angular/core';
import { FeederService } from '../../services/feeder.service';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TransformerManagerService } from '../../services/transformerManager.service';
import { AddUpdateFeederComponent } from './add-update-feeder/add-update-feeder.component';
import { ConfirmationDailogComponent } from '../../confirmation-dailog/confirmation-dailog.component';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-feedermanager',
  templateUrl: './feedermanager.component.html',
  styleUrls: ['./feedermanager.component.scss']
})
export class FeedermanagerComponent implements OnInit {

  currentUserData = JSON.parse(localStorage.getItem('userData'))
  roleID = this.currentUserData.roleid;
  userID = this.currentUserData.userid;
  dataSource;
  deviceMaster: any;
  displayedColumns = ['id', 'sitename', 'deviceID', 'actions', 'state'];

  @ViewChild(MatPaginator, {static:true}) paginator: MatPaginator;
  @ViewChild(MatSort,  {static:true}) sort: MatSort;

  constructor(private feederService: FeederService, private matDialog: MatDialog, private transformerMangSer: TransformerManagerService, private toastr: ToastrService, private ngxLoader: NgxUiLoaderService) { }

  ngOnInit() {
    localStorage.setItem('selectedButton', 'feedermanager');
    this.transformerMangSer.getDeviceDdl().toPromise().then((response: any) => {
      this.deviceMaster = response.data;
      console.log("response dtmu>>>>>>", this.deviceMaster);
    });
    this.getFeederManagerInfo();
  }

  getFeederManagerInfo(){
    //this.ngxLoader.startLoader("feederManager");
    this.feederService.getFeederManagerInfo({"roleid":this.roleID, "userid":this.userID}).subscribe((response:any) => {
      console.log("RESPONSE FOR MANAGER", response);
      if(response.data.length > 0){
        this.dataSource = new MatTableDataSource(response.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log("DATASOURCE >>>>", this.dataSource);
      } else {
        console.log("NO DATA FOR THIS USER")
      }
      //this.ngxLoader.stopLoader("feederManager")
    });
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  editData(serialNumber){
    console.log("SERIAL NUMBER>>>>>", serialNumber);
    this.feederService.getFeederDetails({'feederid': serialNumber}).subscribe((response:any) => {
      //CODE TO READ INTO feederData
      
      var feederData = response.details.message;
      console.log("FEEDER DATA >>>>", feederData);
      this.openDialog('update', feederData)
      
    });
  }

  openDialog(action: any, feederData?: any){
    let dialogRef;
    if(action.toLowerCase()=='add'){
      dialogRef = this.matDialog.open(AddUpdateFeederComponent, {
        height:'70%',
        width:'50%',
        data: {'deviceMaster':this.deviceMaster, 'action': 'add'}
      });
    } else if(action.toLowerCase() == 'update'){
      dialogRef = this.matDialog.open(AddUpdateFeederComponent, {
        height:'70%',
        width:'50%',
        data: {'feederData': feederData,'deviceMaster': this.deviceMaster, 'action': 'update'}
      });
    }

    dialogRef.afterClosed().subscribe(result => {
      // Call ngOnInit after the dialog is closed
      this.ngOnInit();
    });
  }

  deleteData(serialNumber){
    console.log('SERIAL NUMBER:', serialNumber);
    let dialogRef = this.matDialog.open(ConfirmationDailogComponent);
    dialogRef.afterClosed().subscribe((response) => {
      if(response){
        this.feederService.addUpdateFeeder({'action':'delete', 'data':{'deleteFlag': 'D','serialnumber': serialNumber}}).subscribe((response: any) => {
          console.log("response>>>>>>", response);
          //window.location.reload();
          this.toastr.success(response.message)
          this.ngOnInit();
        });
      }
    });
  }

}
